export const RADII = {
  $2xl: 16,
  $3xl: 24,
  $default: 6,
  $full: 9999,
  $lg: 8,
  $md: 6,
  $none: 0,
  $sm: 4,
  $xl: 12,
  $xs: 2,
}
export type RadiusProp = keyof typeof RADII
